// Components
import { useToggleCalculatedValues } from 'hooks/useFeatureFlag';
import type { KeyValueCallback } from 'types/utils.type';
import { EReportTemplateType, type TReportTemplate } from '@timeedit/types';
// Types
import CalculatedValuesSettings from './CalculatedValuesSettings';
import DataSource from './DataSource';
import FieldSettings from './FieldsSettings';
import GeneralInfo from './GeneralInfo';
import Thresholds from './Thresholds';
import TimeSetting from './TimeSetting';
import './ReportTemplate.scss';

export interface TReportTemplateProps {
  data: TReportTemplate;
  onChange: KeyValueCallback<TReportTemplate>;
}

const ContentDetail = (
  props: Omit<TReportTemplateProps, 'data'> & {
    data?: TReportTemplate;
  }
) => {
  const { data, onChange } = props;

  const toggleCalculatedValuesEnabled = useToggleCalculatedValues();

  if (!data) {
    return null;
  }

  return (
    <div className="report-template">
      <GeneralInfo data={data} onChange={onChange} />
      <TimeSetting data={data} onChange={onChange} />
      <DataSource data={data} onChange={onChange} />

      {[
        EReportTemplateType.UTILIZATION,
        EReportTemplateType.HEATMAP,
        EReportTemplateType.DEMAND_ANALYTIC,
      ].includes(data.templateType) && (
        <Thresholds data={data} onChange={onChange} />
      )}

      {[
        EReportTemplateType.UTILIZATION,
        EReportTemplateType.LOAD,
        EReportTemplateType.DEMAND_ANALYTIC,
      ].includes(data.templateType) &&
        toggleCalculatedValuesEnabled && (
          <CalculatedValuesSettings data={data} onChange={onChange} />
        )}

      <FieldSettings data={data} onChange={onChange} />
    </div>
  );
};

export default ContentDetail;
